import { type LegalSourceCitationBehavior } from '#app/services/legal-ai/shared/source-contract.ts'
import { type OfficialPublicationPayload } from '#app/services/official-publications/types.ts'

export const costaRicaBoletinJudicialCitation: LegalSourceCitationBehavior<OfficialPublicationPayload> = {
	title: payload => payload.title || `Boletín Judicial del ${payload.publicationDate}`,
	url: payload => `/archivos/boletin/${payload.snapshotId}`,
	fallbackUrl: snapshotId => `/archivos/boletin/${snapshotId}`,
	inlineTagName: 'boletinjudicialdocument',
	legacyTagNames: ['BoletinJudicialDocument'],
	inlineSecondaryText: payload => payload.publicationDate,
	iconName: 'newspaper',
	linkClassName: 'text-amber-700',
	summaryLabel: 'Boletines Judiciales',
	summaryTitle: payload => payload.title,
}
